export default __webpack_public_path__ + "static/media/avatarA1.aba5b736.png";